import { Tabs } from 'types/Tabs';
import ResumeContractRequest from './ResumeContractRequest';
import ContractRequestSigningPanel from './ContractRequestSigningPanel';
import {
  CampaignDetailModel,
  ContractDetailModel,
  EnvelopeSubmissionModelType,
} from '@urbanx/agx.campaigns.client';
import { NswContractStage } from '@urbanx/agx-ui-components';
import { getEnumValue } from 'helpers/enumHelper';

interface ContractRequestInfoPanelProps {
  campaign: CampaignDetailModel;
  contract: ContractDetailModel;
  currentTab: Tabs;
  mobile?: boolean;
  onPinnedContractChange: (contractId?: string) => void;
}

const ContractRequestInfoPanel = ({
  campaign,
  contract,
  currentTab,
  mobile = false,
  onPinnedContractChange,
}: ContractRequestInfoPanelProps) => {
  const contractStage = contract.contractStage
    ? (getEnumValue(NswContractStage, contract.contractStage) ?? contract.contractStage)
    : undefined;

  if (
    contractStage === NswContractStage.PendingSolicitorExchange ||
    [EnvelopeSubmissionModelType.DocuSign, EnvelopeSubmissionModelType.Email].includes(
      contract.envelopeSubmission?.type ?? EnvelopeSubmissionModelType.Manual
    )
  ) {
    return (
      <ContractRequestSigningPanel
        campaign={campaign}
        currentTab={currentTab}
        mobile={mobile}
        onPinnedContractChange={onPinnedContractChange}
      />
    );
  } else {
    return (
      <ResumeContractRequest
        campaign={campaign}
        contract={contract}
        currentTab={currentTab}
        mobile={mobile}
      />
    );
  }
};

export default ContractRequestInfoPanel;
